import * as Yup from "yup";
import { NetsuiteBatchExportFileCompression, NetsuiteBatchExportFileFormat } from "./model";

export class NetsuiteBatchExportSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      fromDate,
      toDate,
      sync,
    } = recordShape;

    const createFormShape = {
      fromDate: fromDate.required("fromDate é obrigatório"),
      toDate: toDate.default(() => new Date()),
      sync: sync.default(false),
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateCompletedForm() {
    const {
      numberOfRecords,
      fileMd5,
      fileMimetype,
      fileFormat,
      fileStorageKey,
      fileCompression,
    } = recordShape;

    const updateCompletedForm = {
      numberOfRecords: numberOfRecords.required(),
      fileMd5: fileMd5.required(),
      fileMimetype: fileMimetype.required(),
      fileFormat: fileFormat.required(),
      fileStorageKey: fileStorageKey.required(),
      fileCompression,
    };

    return Yup
      .object()
      .shape(updateCompletedForm);
  }
}

const recordShape = {
  fromDate: Yup
    .date()
    .typeError("Valor inválido para fromDate"),
  toDate: Yup
    .date()
    .typeError("Valor inválido para toDate"),
  sync: Yup
    .boolean()
    .typeError("Valor inválido para sync"),
  numberOfRecords: Yup
    .number()
    .min(0, "Valor inválido para numberOfRecords"),
  fileMd5: Yup
    .string()
    .typeError("Valor inválido para fileMd5"),
  fileMimetype: Yup
    .string()
    .typeError("Valor inválido para fileMimetype"),
  fileFormat: Yup
    .mixed<NetsuiteBatchExportFileFormat>().oneOf(Object.values(NetsuiteBatchExportFileFormat), `fileFormat deve ser "${Object.values(NetsuiteBatchExportFileFormat).join('" ou "')}"`),
  fileStorageKey: Yup
    .string()
    .typeError("Valor inválido para fileStorageKey"),
  fileCompression: Yup
    .mixed<NetsuiteBatchExportFileCompression>().oneOf(Object.values(NetsuiteBatchExportFileCompression), `fileCompression deve ser "${Object.values(NetsuiteBatchExportFileFormat).join('" ou "')}"`),
};
